// Route table for the whole portal (investor + Operations), moved out of App.js unchanged (v1.3 ticket 01).
// App builds a browser router from it; tests build a memory router from the same table, so every
// test exercises the real routes and screens.
import LoginRegisterForm from "./component/LoginRegisterForm/LoginRegisterForm.jsx";
import OperationsRootLayout from "./component/Operations/OperationsRootLayout.jsx";
import UpdateMasterData from "./component/Operations/UpdateMasterData/UpdateMasterData.jsx";
import UserRootLayout from "./component/User/UserRootLayout.jsx";
import Portfolio from "./component/User/Portfolio/Portfolio.jsx";
import RootLayout from "./component/Util/RootLayout.jsx";
import ServiceRequest from "./component/User/ServiceRequest/ServiceRequest.jsx";
import LoadingComponent from "./component/Util/LoadingComponent.jsx";
import DownloadForms from "./component/User/DownloadForms/DownloadForms.jsx";
import UserManagement from "./component/Operations/UserManagement/UserManagement.jsx";
import ServiceRequestDetails from "./component/User/ServiceRequest/ServiceRequestDetails/ServiceRequestDetails.jsx";
import ServiceRequestRootLayout from "./component/User/ServiceRequest/ServiceRequestRootLayout.jsx";
import PublicPageLayout from "./component/Util/PublicPageLayout.jsx";
import AccessibilityHelp from "./component/AccessibilityHelp/AccessibilityHelp.jsx";
import NotFound from "./component/NotFound/NotFound.jsx";

// RCMC-07 (ticket 11): each page route names its page in `handle.title`; the shell (Util/PortalShell) titles the
// tab "<title> | RCMC RTA". The sign-in screen titles itself by mode (Sign in / Create account / Reset password).
const SERVICE_REQUEST_TITLE = ({ requestId }) => `Service Request ${requestId}`;

export const routes = [
  {
    path:"/",
    element:<LoadingComponent />,
    children:[
      {
        path:"/",
        element:<RootLayout />
      },
      {
        path:"/operations",
        element:<OperationsRootLayout />,
        children:[
          // Ticket 22 (Q35): "/operations" itself has no page; v1.2 showed the shell with nothing in it
          {
            index:true,element:<NotFound />,handle:{title:"Page not found"}
          },
          {
            path:"update-master-data",element:<UpdateMasterData />,handle:{title:"Update Master Data"}
          },
          {
            path:"service-request",
            element:<ServiceRequestRootLayout />,
            children:[
              {
                path:"",
                element:<ServiceRequest />,
                handle:{title:"Service Requests"}
              },
              {
                path:":requestId",
                element:<ServiceRequestDetails />,
                handle:{title:SERVICE_REQUEST_TITLE}
              }
            ]
          },
          {
            path:"download-forms",
            element:<DownloadForms />,
            handle:{title:"Forms & FAQs"}
          },
          {
            path:"user-management",
            element:<UserManagement />,
            handle:{title:"Users"}
          }
        ]
      },
      {
        path:"user",
        element:<UserRootLayout />,
        children:[
          // Ticket 22 (Q35): "/user" itself has no page; v1.2 showed the shell with nothing in it
          {
            index:true,element:<NotFound />,handle:{title:"Page not found"}
          },
          {
            path:"portfolio",element:<Portfolio />,handle:{title:"Portfolio"}
          },
          {
            path:"service-request",
            element:<ServiceRequestRootLayout />,
            children:[
              {
                path:"",
                element:<ServiceRequest />,
                handle:{title:"Service Requests"}
              },
              {
                path:":requestId",
                element:<ServiceRequestDetails />,
                handle:{title:SERVICE_REQUEST_TITLE}
              }
            ]
          },
          {
            path:"download-forms",element:<DownloadForms />,handle:{title:"Forms & FAQs"}
          }
        ]
      }
    ]
  },
  {
    path:'/login',
    element:<LoginRegisterForm />
  },
  // RCMC-15 (ticket 12): public, so outside LoadingComponent (which sends anyone without a session to sign-in).
  // PublicPageLayout puts it in the portal shell: with the investor navigation for a signed-in Investor, without for anyone else.
  {
    path:"/accessibility-help",
    element:<PublicPageLayout />,
    children:[
      {
        index:true,element:<AccessibilityHelp />,handle:{title:"Accessibility help"}
      }
    ]
  },
  // Ticket 22 (Q35): any address no route above matches ("/user/nope", "/nope"). v1.2 fell through to React Router's own
  // error screen. Public, like Accessibility help: signed in or not, it never sends anyone to sign-in first. (A pathless
  // layout around a "*" page: an index route under a "*" parent matches nothing.)
  {
    element:<PublicPageLayout />,
    children:[
      {
        path:"*",element:<NotFound />,handle:{title:"Page not found"}
      }
    ]
  }
];
